import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import InputEdit from "../../components/input/InputEdit";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import { useDispatch, useSelector } from "react-redux";

import TopTabs from "../../components/TopTabs";
import { useParams } from "react-router-dom";

const EditItems = () => {
  const { sectionData, filterData } = useSelector((state) => state.menu);

  const { outlet } = useParams();

  const data = [
    {
      name: "Edit Food",
      url: `/manage/${outlet}/edit/food`,
    },
    {
      name: "Edit Filter",
      url: `/manage/${outlet}/edit/filter`,
    },

    {
      name: "Edit Section",
      url: `/manage/${outlet}/edit/section`,
    },
  ];

  return (
    <div className="edit-items">
      <TopTabs data={data} size="sm" />
    </div>
  );
};

export default EditItems;
